export default {
    payedTitle: 'Show {{count}} more',
    needPayTitle: 'Go to payment and show more',
    companies: {
        zero: 'companies',
        one: 'company',
        few: 'companies',
        many: 'companies',
        other: 'companies'
    }
};
